export const W9_TAB_KEY = 'w9';

export const FORMIK_W9_FIELD_IDS = {
  W9_DATE: 'w9_date',
  TIN: 'tin',
  W9_DOCUMENT_ID: 'w9_document_id',
  IS_1099_REPORTABLE: 'is_1099_reportable',
  REPORT_TYPE_1099: 'report_type_1099',
};
